import type IMDFFeature from "@/libs/imdf/feature";

export type ThemeEditorProperties = {
  selected: boolean;
};

export enum IMDF_EVENTS {
  INIT = "imdf.init",
  PROCESS_NON_EXTRUDED = "imdf.process.non_extruded",
  PROCESS_EXTRUDED = "imdf.process.extruded",
  PROCESS_POINTS = "imdf.process.points",
}

export type IMDFConfig = {
  extrudePolygons: boolean;
  polygonMargin: number;
};

export type ProcessEvent = Exclude<IMDF_EVENTS, IMDF_EVENTS.INIT>;

export type FeatureByLevelHashMap = {
  [ordinal: number]: Array<IMDFFeature>;
};
